module.exports = __webpack_public_path__ + "static/EnmTX_BosDarius_L_A_cl-bc724d01be471045b27e4ce4bbea99c8.gif";